var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0452 16.2056L14.1477 13.3081C15.1967 12.0652 15.834 10.4612 15.834 8.7085C15.834 4.77391 12.6436 1.5835 8.70898 1.5835C4.7744 1.5835 1.58398 4.77391 1.58398 8.7085C1.58398 12.6431 4.7744 15.8335 8.70898 15.8335C10.4625 15.8335 12.0657 15.197 13.307 14.1472L16.2045 17.0447C16.3209 17.1603 16.4737 17.2189 16.6241 17.2189C16.7745 17.2189 16.9289 17.1611 17.0437 17.0447C17.2772 16.8128 17.2772 16.4375 17.0452 16.2056ZM2.77148 8.7085C2.77148 5.43495 5.43544 2.771 8.70898 2.771C11.9825 2.771 14.6465 5.43495 14.6465 8.7085C14.6465 11.982 11.9825 14.646 8.70898 14.646C5.43544 14.646 2.77148 11.982 2.77148 8.7085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.23a68e96ff1bc3652f84798814275da5.svg";
export { ForwardRef as ReactComponent };